import { useFormikContext } from 'formik'
import { useEffect, useRef, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { DEFAULT_DEBOUNCE_TIME } from '../defaultDebounceTime'
import { checkUrlRedirect, isCheckableUrl, UrlRedirectCheckOutcome } from '../urlRedirectCheck'

export function useUrlRedirectCheck(fieldName: string, value: string): UrlRedirectCheckOutcome | null {
  const { initialValues } = useFormikContext<Record<string, unknown>>()
  const initialValue = String(initialValues[fieldName] ?? '')
  const [debouncedValue] = useDebounce(value, DEFAULT_DEBOUNCE_TIME)
  const [outcome, setOutcome] = useState<UrlRedirectCheckOutcome | null>(null)
  const requestIdRef = useRef(0)

  useEffect(() => {
    const trimmed = debouncedValue.trim()
    const initialTrimmed = initialValue.trim()

    if (!trimmed || trimmed === initialTrimmed || !isCheckableUrl(trimmed)) {
      setOutcome(null)
      return
    }

    const requestId = ++requestIdRef.current
    const abortController = new AbortController()

    void checkUrlRedirect(trimmed, fetch, abortController.signal).then((result) => {
      if (requestId !== requestIdRef.current) {
        return
      }
      if (result.kind === 'none') {
        setOutcome(null)
        return
      }
      setOutcome(result)
    })

    return () => {
      abortController.abort()
      requestIdRef.current += 1
    }
  }, [debouncedValue, initialValue])

  return outcome
}
